// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__GqKsN","isLink":"Button_isLink__Zj6NI"};